import { render, staticRenderFns } from "./SlotSymbol.vue?vue&type=template&id=0ab0ba12&scoped=true"
import script from "./SlotSymbol.vue?vue&type=script&lang=js"
export * from "./SlotSymbol.vue?vue&type=script&lang=js"
import style0 from "./SlotSymbol.vue?vue&type=style&index=0&id=0ab0ba12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0ba12",
  null
  
)

export default component.exports